<template lang="html">
  <div :class='{"tabs__light": mode === "light", "tabs__dark": mode === "dark"}'>
    <ul class='referral-tabs'>
      <li v-for='(tab, index) in tabs'
        :key='tab.title'
        @click='selectTab(index)'
        :class='{"active": (index == selectedIndex)}'>
        {{ tab.title }}
      </li>
      <div class="collapse p-2 is-align-self-center m-l-10-tablet" @click="$emit('isShowAllPlatform')">
        <a v-if="showall" class="is-has-text-nowrap expand-collapse-link expand-collapse has-text-underline">
          With Platforms Only
        </a>
        <a v-else class="is-has-text-nowrap expand-collapse-link expand-collapse has-text-underline">
          Show All
        </a>
      </div>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'light',
    },
    currentTab: {
      type: Number,
      default: 0,
    },
    showall: Boolean
  },
  data () {
    return {
      selectedIndex: 0, // the index of the selected tab,
      tabs: []         // all of the tabs
    }
  },
  created () {
    this.tabs = this.$children
  },
  mounted () {
    this.selectTab(this.currentTab);
  },
  methods: {
    selectTab (i) {
      this.selectedIndex = i;
      this.$store.commit("search/SET_CURRENT_TAB", i)

      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i)
      })
    }
  }
}
</script>
